export default {
  methods: {
    setSidebarOpen(status) {
      if (status === false) {
        this.$root.$emit("close");
      }
    },
  },
};
